<template>
  <div>
    <v-row justify="center" align="center" class="splash ma-0">
      <v-col class="custom-font splash-content pl-8 pr-4 py-10" cols="12" md="6">
        <div class="fade-in-text caos-font">Chuteout</div>
        <div class="fade-in-text caos-font">Action</div>
        <div class="fade-in-text caos-font">Obsessed</div>
        <div class="fade-in-text caos-font">Sports</div>
        <v-btn to="/suits" size="large" variant="outlined" v-ripple
          class="mt-6 elevation-2 custom-font fade-in-text btn-gradient-2">
          Shop Custom Suits Now
        </v-btn>
      </v-col>
      <v-col class="d-none d-md-flex pa-6" cols="12" md="6">
        <v-img class="fade-in-image" src="https://storage.googleapis.com/caos-suits-v2/Hero.png" />
      </v-col>
    </v-row>

    <section class="py-8 px-4">
      <v-row>
        <v-col
          v-for="item in testimonials"
          :key="item.id"
          cols="12"
          sm="6"
        >
          <v-card class="testimonial-card pa-4" height="100%" elevation="2">
            <div class="d-flex flex-column align-center">
              <v-avatar class="mb-4" :size="80">
                <img :src="getImage(item)" :alt="item.name" />
              </v-avatar>
              <p class="testimonial-text text-center mb-4">{{ item.text }}</p>
              <p class="text-center font-weight-bold mb-0">— {{ item.name }} —</p>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </section>
  </div>
</template>

<script>
import { useHead } from '@unhead/vue'

export default {
  setup() {
    useHead({
      title: 'Caos Suits | Custom Skydiving Suits Australia',
      meta: [{ name: 'description', content: 'Custom skydiving suits in Australia. Shop freefly, RW, camera, tandem, wingsuit and more — built to order by Caos Suits.' }],
    })
  },
  data() {
    return {
      testimonials: [
        {
          id: 0,
          image: "jaymartin.jpg",
          name: "Jay Martin",
          text:
            "I've purchased two suits from Caos and will definitely get more. Awesome guy, quick and reliable service, and unbeatable prices. Did I mention they were delivered within 30 days? So measurements, stitching it all together, and shipping from across the pond all within 30 days. Amazing. Thanks!",
        },
        {
          id: 1,
          image: "mikeberterant.png",
          name: "Mike Berterant",
          text:
            "Very impressive customer service experience with CAOS. I had a problem with my order and contacted Heath directly. He refunded the purchase immediately and addressed the issue like a champ! Very personable and stand-up service, cheers!",
        },
        {
          id: 2,
          image: "johnashcraft.jpg",
          name: "John Ashcraft",
          text:
            "Can't say enough good things about my Caos suit! Heath has fantastic customer service, the freefly suit flies AMAZING in the sky and tunnel. Very well made, and quick turn around. Will be ordering another soon!",
        },
        {
          id: 3,
          image: "nickbeyel.jpg",
          name: "Nick Beyel",
          text:
            "I purchased my first suit, the hybrid, from Caos and couldn't be happier with it. The fit was excellent, the custom print was easy to order, and the suit turned out amazing. Even after asking for a shipping address change, the order came quickly. Great customer service! Will definitely be ordering more in the near future.",
        },
      ],
    };
  },
  methods: {
    getImage(item) {
      return require(`@/assets/${item.image}`);
    },
  },
};
</script>

<style scoped>
.custom-font {
  font-family: poppins;
}

.btn-gradient-2 {
  color: white;
  background: linear-gradient(black, black) padding-box,
    linear-gradient(to right, #f72f07, #f78b07) border-box;
  border-radius: 1em;
  border: 2px solid transparent;
}

.splash {
  background: black;
  min-height: 70vh;
}

.splash-content {
  color: white;
  font-size: clamp(2rem, 5vw, 3.5rem);
  line-height: 1.15;
}

.caos-font {
  background: -webkit-linear-gradient(#f72f07, #f78b07);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.testimonial-card {
  border-left: 3px solid #f78b07;
}

.testimonial-text {
  font-size: 0.95rem;
  line-height: 1.6;
  color: rgba(0, 0, 0, 0.75);
}

.fade-in-image {
  animation: fadeIn 3s;
}

.fade-in-text {
  animation: fadeIn 3s;
}

@keyframes fadeIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}
</style>
